import { invokeApig, unauthInvokeApig } from '../libs/awsLib';

class usersApi {
  static get(userToken) {
    return invokeApig({ service: 'USER', path: '/users' }, userToken);
  }

  /**
   * @typedef user_role
   * @property {number} user_role.xpas_user_role_id
   * @property {number} user_role.xpas_user_role_id
   * @property {string} user_role.xpas_role_id
   * @property {string} user_role.username
   *
   * @typedef user_team
   * @property {number} user_role.xpas_team_id
   * @property {string} user_role.name
   * @property {boolean} user_role.active_yn
   * @property {number} user_role.user_type_id
   * @property {boolean} user_role.require_case_assignment_yn
   *
   * @typedef {object} profileResult
   * @property {boolean} profileResult.allowSaveWithoutTeam
   * @property {string} profileResult.username
   * @property {boolean} profileResult.enabled
   * @property {string} profileResult.first_name
   * @property {string} profileResult.last_name
   * @property {string} profileResult.phone_number
   * @property {number} profileResult.user_type_id
   * @property {boolean} profileResult.block_alerts
   * @property {boolean} profileResult.use_auto_save
   * @property {boolean} profileResult.isDragonflyUser
   * @property {Array<user_role>} profileResult.user_roles
   * @property {Array<user_team>} profileResult.user_teams
   * @property {string} profileResult.main_organization_id
   * @property {string} profileResult.main_organization_name
   *
   * @param {string} userToken
   * @returns {Promise<profileResult}
   */
  static getProfile(userToken) {
    return invokeApig({ service: 'USER', path: '/profile' }, userToken);
  }

  static async getUser(username, userToken) {
    return invokeApig(
      {
        service: 'USER',
        path: '/users/details?xpas_username=' + +encodeURIComponent(username),
      },
      userToken
    );
  }

  static forgotpassword(username) {
    return unauthInvokeApig(
      {
        service: 'USER',
        path: '/users/forgot-password',
        method: 'POST',
        body: {
          xpas_username: username,
        },
      },
      null
    );
  }

  static changePasswordActiveUser(
    accessToken,
    previousPassword,
    proposedPassword,
    userToken
  ) {
    return invokeApig(
      {
        service: 'USER',
        path: '/users/change-password',
        method: 'POST',
        body: {
          access_token: accessToken,
          previous_password: previousPassword,
          proposed_password: proposedPassword,
        },
      },
      userToken
    );
  }

  static changePassword(email, code, password) {
    return unauthInvokeApig(
      {
        service: 'USER',
        path: '/users/change-password-code',
        method: 'POST',
        body: {
          username: email,
          code: code,
          password: password,
        },
      },
      null
    );
  }

  static update(user, userToken) {
    if (user.phone_number[0] !== '+') {
      user.phone_number = '+' + user.phone_number;
    }

    return invokeApig(
      {
        service: 'USER',
        path: '/users',
        method: 'PUT',
        body: user,
      },
      userToken
    );
  }

  static add(user, userToken) {
    if (user.phone_number[0] !== '+') {
      user.phone_number = '+' + user.phone_number;
    }

    return invokeApig(
      {
        service: 'USER',
        path: '/users',
        method: 'POST',
        body: user,
      },
      userToken
    );
  }

  static deleteUser(username, userToken) {
    invokeApig(
      {
        service: 'USER',
        path: '/users?xpas_username=' + username,
        method: 'DELETE',
      },
      userToken
    );
  }

  static enableUser(username, userToken) {
    invokeApig(
      {
        service: 'USER',
        path: '/users/enable',
        body: { xpas_username: username },
        method: 'PUT',
      },
      userToken
    );
  }

  static disableUser(username, userToken) {
    invokeApig(
      {
        service: 'USER',
        path: '/users/disable',
        body: { xpas_username: username },
        method: 'PUT',
      },
      userToken
    );
  }

  static async isUserAssignedToEntityMerlot(username, entityId, userToken) {
    const result = await invokeApig(
      {
        service: 'USER',
        path: `/users/${username}/entity/${entityId}`,
        method: 'GET',
      },
      userToken
    );
    return result;
  }

  static async areUsersAssignedToEntityMerlot(usernames, entityId, userToken) {
    try {
      const result = await invokeApig(
        {
          service: 'USER',
          path: `/users/merlot/entity`,
          method: 'POST',
          body: {
            usernames: usernames,
            entityId: entityId,
          },
        },
        userToken
      );
      return result;
    } catch (e) {
      console.log(e);
    }
  }

  static async isUserAssignedToEntitiesMerlot(username, entityIds, userToken) {
    try {
      const result = await invokeApig(
        {
          service: 'USER',
          path: `/users/merlot/entities`,
          method: 'POST',
          body: {
            username: username,
            entityIds: entityIds,
          },
        },
        userToken
      );
      return result;
    } catch (e) {
      console.log(e);
    }
  }
}
export default usersApi;
